"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = exports.DateTime = exports.Amount = exports.Action = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _get = _interopRequireDefault(require("lodash/get"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _ProductIconContainer = _interopRequireDefault(require("../../common/ProductIcon/ProductIconContainer"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _dateHelper = require("../../../helpers/dateHelper");
require("./ActivityComponents.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var Action = exports.Action = function Action(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation.t;
  var themeModifier = props.themeModifier;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "sell",
    customClass: baseClasses('type-icon')
  }), /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    customClass: baseClasses('product-icon', themeModifier),
    iconFileName: props.value.iconFileName,
    size: 36
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-column')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-text', 'primary')
  }, t('Earned ' + (0, _get["default"])(props, 'value.Product', '')))));
};
var Amount = exports.Amount = function Amount(props) {
  var _props$value = props.value,
    ProductSymbol = _props$value.ProductSymbol,
    CR = _props$value.CR;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount'),
    style: {
      paddingLeft: '2.8rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-quantity')
  }, "".concat((0, _numberFormatter.formatNumberToLocale)(CR, ProductSymbol), " ").concat(ProductSymbol || '')));
};
var Status = exports.Status = function Status(props) {
  (0, _reactI18next.useTranslation)('activity');
  var TransactionId = props.value.TransactionId;
  var customClass = props.customClass;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(customClass, " ").concat(baseClasses('status'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('status-id')
  }, TransactionId));
};
var DateTime = exports.DateTime = function DateTime(props) {
  var TimeStamp = props.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('date', 'noPadLeft')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('date-date')
  }, (0, _dateHelper.formatDate)(TimeStamp)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('date-time')
  }, (0, _dateHelper.formatTime)(TimeStamp)));
};
Status.defaultProps = {
  customClass: ''
};